import { render, staticRenderFns } from "./RequstedIncidentNotification.vue?vue&type=template&id=3f1fa66d&"
import script from "./RequstedIncidentNotification.vue?vue&type=script&lang=js&"
export * from "./RequstedIncidentNotification.vue?vue&type=script&lang=js&"
import style0 from "./RequstedIncidentNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports